import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useLenis } from "lenis/react";
import { motion, AnimatePresence } from "framer-motion";
import Hero from "@/components/Hero";
import Problem from "@/components/Problem";
import Services from "@/components/Services";
import System from "@/components/System";
import AISection from "@/components/AISection";
import Creative from "@/components/Creative";
import WebInfra from "@/components/WebInfra";
import Who from "@/components/Who";
import Work from "@/components/Work";
import Why from "@/components/Why";
import About from "@/components/About";
import Contact from "@/components/Contact";

export default function HomePage() {
  const location = useLocation();
  const lenis = useLenis();
  const [intro, setIntro] = useState(() => !sessionStorage.getItem("tpa_intro_seen"));

  useEffect(() => {
    if (!intro) return;
    document.body.style.overflow = "hidden";
    const t = setTimeout(() => {
      sessionStorage.setItem("tpa_intro_seen", "1");
      document.body.style.overflow = "";
      setIntro(false);
    }, 2300);
    return () => {
      clearTimeout(t);
      document.body.style.overflow = "";
    };
  }, [intro]);

  useEffect(() => {
    if (location.state?.scrollTo) {
      const t = setTimeout(() => lenis?.scrollTo(location.state.scrollTo, { offset: -72 }), 300);
      return () => clearTimeout(t);
    }
  }, [location.state, lenis]);

  return (
    <main>
      <AnimatePresence>
        {intro && (
          <motion.div
            key="tpa-intro"
            data-testid="intro-overlay"
            className="fixed inset-0 z-[200] flex flex-col items-center justify-center bg-obsidian"
            exit={{ opacity: 0, scale: 1.04 }}
            transition={{ duration: 0.7, ease: "easeInOut" }}
          >
            <motion.img
              src="/assets/logo-mark.png"
              alt="The Polemikoi Agency"
              initial={{ opacity: 0, scale: 0.72, filter: "blur(10px)" }}
              animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
              transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
              className="h-28 w-auto md:h-36"
            />
            <motion.p
              initial={{ opacity: 0, y: 14 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.75, duration: 0.7 }}
              className="mt-8 font-mono text-[10px] uppercase tracking-[0.45em] text-zinc-500"
            >
              The Polemikoi Agency
            </motion.p>
          </motion.div>
        )}
      </AnimatePresence>
      <Hero delayBase={intro ? 2.3 : 0} />
      <Problem />
      <Services />
      <System />
      <AISection />
      <Creative />
      <WebInfra />
      <Who />
      <Work />
      <Why />
      <About />
      <Contact />
    </main>
  );
}
